import React, { useEffect, useContext, useState } from "react";
import studylistContext from "../../../../context/studylist/StudylistContext";
import "./MobileStudyList.css";
import { t } from "i18next";
import {
  Checkbox,
  Dropdown,
  Icon,
  PrimaryButton,
  Stack,
  TextField,
  IconButton,
  Calendar,
  SearchBox,
  defaultDatePickerStrings,
  DatePicker
} from "@fluentui/react";
import { TabList, Tab } from "@fluentui/react-tabs";
import {
  checkboxStyle,
  getCurrentActiveTabName,
  getCurrentActiveTabId,
  menuPropsItems,
  options,
  searchIcon,
  searchInputStyle,
  sortingMenuPropsItems,
  sortOptionsFunction,
} from "../../helpers/mobileUtilities";
import { initPaginationData } from "../../helpers/initData";
import {
  handleDropDownClick,
  onTabSelect,
} from "../../helpers/helpingFunctions";
import SearchFilter from "../Filters/Components/SearchFilter";
import { FILTER_TYPE, USERTYPES } from "../../../../constants/Constants";
import { init_pathology_state } from "../../../Annotations/helper/initialData";
import BackResIcon from "../../../../components/SVGComponents/ResponsiveScreenIcon/BackResIcon";
import themeContext from "../../../../context/theme/ThemeContext";

const MobileStudyListFilters = (props) => {
  const {
    setAllStudies,
    studyData,
    columns,
    allStudies,
    searchDto,
    setSearchDto,
    sortGlobal,
    setSortGlobal,
    filterInputValues,
    showFilters,
    setShowFilters,
    applyClick,
    setApplyClick,
    storefilterBadges,
    setStoreFilterBadges,
    filterBadges,
    setPaginationObj,
    setFilterBadges,
    handleChangeSizeIndex,
    returnedStudyCountApiFunc,
    roles,
    hideModal,
    showCommunicationModal,
    setShowReturnedStudyReasonModal,
    showReturnedStudyReasonModal,
    showCount,
    setShowCount,
    patientNameBadgeShow,
    removeBadgeFromFilter,
    setPatientDetail,
    setPatientNameBadgeShow,
    setModalityIds,
    refreshRequired,
    setRefreshRequired,
    storedRows,
    setStoredRows,
    setShowClientName,
    setDataQueryState,
    setSearchResultLength,
    dataQueryState,
    showVersionModalForReport,
    handleEnterKeyPress,
    showGenericConfirmModal,
    setShowGenericConfirmModal,
    handleGenericConfirmModal,
    confirmMessage,
    setConfirmMessage,
    showDeleteModal,
    setShowDeleteModal,
    deleteStudyFunc,
    handleCloseDeleteModal,
    showDeleteSuccessModal,
    setShowDeleteSuccessModal,
    deleteSuccessMessage,
    setDeleteSuccessMessage,
    showReInferenceModal,
    setShowReInferenceModal,
    handleCloseReInferenceModal,
    showConfirmModalState,
    setShowConfirmModalState,
    handleBatchReInference,
    selectedValue,
    setSelectedValue,
    unreportedAllTabs,
    setUnreportedAllTabs,
    handleCXRTabChange,
    searchResultLengthObj,
    setSearchResutLengthObj,
    filterApplied,
    setFilterApplied,
    setResetRowSelection,
    alertSuccessStudyListState,
    setAlertSuccessModalStudyListState,
    trackApplyButton,
    setTrackApplyButton,
    fetchData,
    checkForConditionRequired,
    handleMobileClearFilter,
    setFilterInputValues,
    storefilterInputValues
  } = useContext(studylistContext);

  const [selectedTab, setSelectedTab] = useState("filter_0");
  const [textFieldFocus, setTextFieldFocus] = useState(false);

  const onTabSelect = (event, data) => {
    console.log("--- Value ---", data);
    setSelectedTab(data.value);
  };

  useEffect(() => {
    const onBeforeUnload = (event) => {
      // Prevent the user from leaving the page
      console.log("---Before-Unloading Running---",event);
      if(props.isMobileFilterOpen){
        props.togglePopup();
        event.returnValue = '';
        event.preventDefault();
      }
      
     
    };
    console.log("---Event beforeunload Added---")
    window.addEventListener('beforeunload', onBeforeUnload);
  
    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
    };
  }, []);

  const tabDetailsMobile = () => {
    let items = [
      {
        selectedKey: "filter_0",
        tabKeyContain: (
          <TabHeaderDetails
            active={selectedTab === "filter_0"}
            filterActive={true}
            title={t("label.sort")}
          />
        ),
        tabValueContain: <TabContentDetails id="sort" />,
        tabValueHeading: t("label.sort-by"),
      },
      // {
      //     selectedKey: "filter_1",
      //     tabKeyContain:
      //     <TabHeaderDetails active={selectedTab === "filter_1"}
      //     filterActive={patientNameBadgeShow &&
      //         searchDto.patientNameOrId != null &&
      //         searchDto.patientNameOrId.length > 0}
      //     title="Patient" />,
      //     tabValueContain: <TabContentDetails id = "patient" />,
      //     tabValueHeading: t("label.search-by")
      // },
      {
        selectedKey: "filter_1",
        tabKeyContain: (
          <TabHeaderDetails
            active={selectedTab === "filter_1"}
            title={t("navbar.modality")}
            filterActive={
              searchDto?.modalityIds != null &&
              searchDto?.modalityIds.length > 0
            }
          />
        ),
        tabValueContain: <TabContentDetails id="modality" />,
        tabValueHeading: `${t("label.filter-by")} ${t("navbar.modality")}`,
        showSearchBox: true,
        searchBoxtype: FILTER_TYPE.ModalityList,
      },
      {
        selectedKey: "filter_2",
        tabKeyContain: (
          <TabHeaderDetails
            active={selectedTab === "filter_2"}
            title="Upload Date Range"
            filterActive={
              searchDto.uploadDate != null && searchDto.uploadDate != undefined
            }
          />
        ),
        tabValueContain: <TabContentDetails id="uploadDate" />,
        tabValueHeading: `${t("label.filter-by")} ${t("label.upload-date")}`,
        showSearchBox: false,
        searchBoxtype: null,
      },
      {
        selectedKey: "filter_3",
        tabKeyContain: (
          <TabHeaderDetails
            active={selectedTab === "filter_3"}
            title="Study Date"
            filterActive={
              (searchDto.studyDateFrom != null && searchDto.studyDateFrom != undefined) ||
              (searchDto.studyDateTo != null && searchDto.studyDateTo != undefined)
            }
          />
        ),
        tabValueContain: <TabContentDetails id="studydate" />,
        tabValueHeading: `${t("label.filter-by")} ${t("label.study-date")}`,
        showSearchBox: false,
        searchBoxtype: null,
      },
      // {
      //     selectedKey: "filter_5",
      //     tabKeyContain:
      //     <TabHeaderDetails active={selectedTab === "filter_5"} title={t("navbar.pathology")}
      //     filterActive={searchDto.annotationId != null && searchDto.annotationId != undefined}
      //     />,
      //     tabValueContain:<TabContentDetails id = "pathology" />,
      //     tabValueHeading: `${t("label.filter-by")} ${t("navbar.pathology")}`,
      //     showSearchBox: true,
      //     searchBoxtype: FILTER_TYPE.AnnotationList
      // },
      // {
      //     selectedKey: "filter_6",
      //     tabKeyContain:
      //     <TabHeaderDetails active={selectedTab === "filter_6"} title={t("navbar.priority")}
      //     filterActive={searchDto.aiPredictionId != null && searchDto.aiPredictionId != undefined}
      //     />,
      //     tabValueContain:<TabContentDetails id = "priority" />,
      //     tabValueHeading: `${t("label.filter-by")} ${t("navbar.priority")}`,
      //     showSearchBox: false,
      //     searchBoxtype: null
      // }
    ];
    let filterCount = 4;
    if (
      roles[0] === USERTYPES.ADMIN ||
      roles[0] === USERTYPES.FIRMADMIN ||
      roles[0] === USERTYPES.SUPERVISOR
    ) {
      items.push({
        selectedKey: "filter_"+filterCount,
        tabKeyContain: (
          <TabHeaderDetails
            active={selectedTab === "filter_"+filterCount}
            title={`${
              roles[0] === USERTYPES.ADMIN
                ? t("navbar.firms")
                : t("navbar.clients")
            }`}
            filterActive={
              searchDto.clientOrFirmIds != null &&
              searchDto.clientOrFirmIds != undefined
            }
          />
        ),
        tabValueContain: <TabContentDetails id="client" />,
        tabValueHeading: `${t("label.filter-by")} ${
          roles[0] === USERTYPES.ADMIN ? t("navbar.firms") : t("navbar.clients")
        }`,
        showSearchBox: true,
        searchBoxtype: FILTER_TYPE.ClientFirmList,
      });
      filterCount++;
    }
    if (
      roles[0] === USERTYPES.ADMIN ||
      roles[0] === USERTYPES.FIRMADMIN ||
      roles[0] === USERTYPES.SUPERVISOR || 
      roles[0] === USERTYPES.RADIOLOGIST
    ) {
      items.push({
        selectedKey: "filter_"+filterCount,
        tabKeyContain: (
          <TabHeaderDetails
            active={selectedTab === "filter_"+filterCount}
            title={t("navbar.providers")}
            filterActive={
              searchDto.providerIds != null &&
              searchDto.providerIds != undefined
            }
          />
        ),
        tabValueContain: <TabContentDetails id="provider" />,
        tabValueHeading: `${t("label.filter-by")} ${t("navbar.providers")}`,
        showSearchBox: true,
        searchBoxtype: FILTER_TYPE.RadiologistList,
      });
    }
    return items;
  };

  useEffect(() => {
    if (trackApplyButton) {
    }
  }, [trackApplyButton]);

  return (
    <>
      {
        <div
          className="popup-content"
          style={{ height: textFieldFocus ? "calc(100vh - 100px)" : "60vh" }}
        >
          {textFieldFocus ? (
            <PatientSearchMobilePage
              togglePopup={props.togglePopup}
              setTextFieldFocus={setTextFieldFocus}
            />
          ) : (
            <>
              {/* Filter options */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  flexDirection: "column",
                  alignItems: "center",
                  height: "20%",
                  borderBottom: "1px solid #3D3D3D",
                  padding: "10px",
                  boxSizing: "border-box",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span className="study-list-mobile-filter-txt">
                    {t("button.filter")}
                  </span>
                  <div className="study-list-mobile-close-icon-div">
                    <IconButton
                      //style={{ color: "white" }}
                      //style={{color : "var(--navbar-header-popup-color-txt)"}}
                      style={{color : "var(--mobile-color-txt)"}}
                      iconProps={{ iconName: "Cancel" }}
                      ariaLabel="Close popup filter mobile"
                      onClick={()=>{ setFilterInputValues(storefilterInputValues);props.togglePopup()}}
                    />
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <TabContentDetails
                    id="patient"
                    handleSearchFocus={(flag) => {
                      console.log("Search clicked", flag);
                      setTextFieldFocus(flag);
                    }}
                  />
                </div>
              </div>
              {/* Apply and cancel buttons */}
              <MobileFilterTabs
                selectedValue={selectedTab}
                onTabSelect={onTabSelect}
                uniqueKey="filter_"
                tabDetails={tabDetailsMobile()}
              />
              <div className="study-list-mobile-filter-button-section">
                <PrimaryButton
                  text={t("button.apply")}
                  onClick={() => {
                    setTrackApplyButton(true);
                    if (searchDto?.patientNameOrId?.length > 0) {
                      setPatientNameBadgeShow(true);
                    }
                    setFilterInputValues(storefilterInputValues);
                    handleChangeSizeIndex(0, 50, "");
                    setSelectedValue(selectedValue);

                    setApplyClick(true);
                    setTimeout(() => {
                      console.log("--- Fetching Data ---", searchDto);

                      let filterUpdated = filterApplied + 1;
                      setFilterApplied(filterUpdated);
                      setStoreFilterBadges(filterBadges);
                      props.togglePopup();
                    }, 500);
                  }}
                  className={
                    !trackApplyButton
                      ? "common-default-active-button"
                      : "common-default-inactive-button"
                  }
                />
                <PrimaryButton
                  text={t("button.clear-all")}
                  onClick={() =>
                    setTimeout(() => {
                      props.togglePopup();
                      setSelectedTab("filter_0");
                      setFilterInputValues(storefilterInputValues);
                      handleMobileClearFilter();
                    }, 500)
                  }
                  className="study-list-clear-all-button"
                />
              </div>
            </>
          )}
        </div>
      }
    </>
  );
};

export default MobileStudyListFilters;

const PatientSearchMobilePage = ({ setTextFieldFocus, togglePopup }) => {
  const { setPatientDetail, patientIdBasedSearch } =
    useContext(studylistContext);
  const searchBoxStyles = { root: { width: 300 } };

  const handleSearch = (val) => {
    console.log("Searching....", val);
    patientIdBasedSearch(val);
    setTextFieldFocus(false);
    togglePopup(false);
  };

  return (
    <>
      <div className="popup-full-page-content">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "30px",
            marginLeft: "10px",
          }}
        >
          <span
            style={{ marginRight: "10px", display: "flex" }}
            onClick={() => {
              setTextFieldFocus(false);
            }}
          >
            <BackResIcon color={"var(--mobile-color-txt)"}/>
          </span>

          <SearchBox
            styles={searchBoxStyles}
            placeholder="Patient Id Or Name"
            onSearch={(newValue) => handleSearch(newValue)}
            autoFocus={true}
          />
        </div>
      </div>
    </>
  );
};

const MobileFilterTabs = (props) => {
  const {
    searchDto,
    filterInputValues,
    setModalityIds,
    storefilterInputValues,
    setFilterInputValues,
  } = useContext(studylistContext);
  const borderStyle = "1px solid #3D3D3D";

  const filterList = (searchInput, searchFilterType) => {
    if (searchInput != null && searchInput != undefined)
      searchInput = searchInput.trim();
    let searchValue = searchInput.toLowerCase();
    let allTemp = storefilterInputValues[searchFilterType];
    if (searchValue != "") {
      const filteredData = allTemp.filter((item) => {
        if (searchFilterType == "radiologistList") {
          let name = item.firstName + " " + item.lastName;
          if (item.name != undefined) {
            name = item.name;
          }
          return name.toLowerCase().includes(searchValue);
        }
        return item.name.toLowerCase().includes(searchValue);
      });
      setFilterInputValues(() => {
        const newItem = { ...filterInputValues };
        newItem[searchFilterType] = filteredData;
        return newItem;
      });
    } else {
      setFilterInputValues(() => {
        const newItem = { ...filterInputValues };
        newItem[searchFilterType] = storefilterInputValues[searchFilterType];
        return newItem;
      });
    }
  };

  const searchStyle = {
    root: {
      background: "transparent",
      border: "1px solid rgba(200, 198, 196, 0.3)",
      borderRadius: "5px",
      height: "11%",
      margin: "0px 10px 9px 10px",
      padding: "0px 10px",
    },
    searchBoxWithRightIcon: {
      // Other styles for SearchBox...
      position: "relative",
    },
    iconContainer: {
      pointerEvents: "none",
      position: "absolute",
      right: 8, // Adjust this value as needed to move the icon to the desired position
      top: "50%",
      transform: "translateY(-50%)",
    },
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          width: "100%",
          height: "70%",
          borderBottom: borderStyle,
        }}
      >
        <TabList
          style={{
            width: "40%",
            height: "100%",
            borderRight: borderStyle,
            padding: "10px 0px 10px 0px",
            boxSizing: "border-box",
            overflow: "auto",
          }}
          className="mobile-modal-scroll"
          defaultSelectedValue={`${props.uniqueKey}1`}
          selectedValue={props.selectedValue}
          onTabSelect={props.onTabSelect}
          vertical
        >
          {props.tabDetails.map((tabElement, index) => {
            return (
              <Tab
                key={index}
                className="tab-container-cmp"
                id={`${props.uniqueKey}${index.toString()}`}
                value={`${props.uniqueKey}${index.toString()}`}
              >
                {tabElement.tabKeyContain}
              </Tab>
            );
          })}
        </TabList>
        <div
          style={{ borderBottom: borderStyle, height: "100%", width: "60%" }}
        >
          {props.tabDetails.map((tabElement, index) => {
            return (
              tabElement.selectedKey == props.selectedValue && (
                <React.Fragment key={index}>
                  <span
                    style={{ padding: "10px 0px 0px 10px", height: "10%" }}
                    className="mobile-sort-search-text"
                  >
                    {tabElement.tabValueHeading}
                  </span>
                  {tabElement.showSearchBox && (
                    <SearchBox
                      placeholder={t("button.search")}
                      styles={searchStyle}
                      onClear={(ev) => {}}
                      iconProps={{
                        iconName: "Search",
                        style: { display: "none" },
                      }}
                      iconRenderer={(props) => {
                        return (
                          <div className={searchStyle.iconContainer}>
                            <Icon {...props} />
                          </div>
                        );
                      }}
                      onChange={(ev, newValue) => {
                        filterList(newValue, tabElement.searchBoxtype);
                      }}
                    />
                  )}
                  <div
                    key={index}
                    className="study-list-mobile-tab-content mobile-modal-scroll"
                    style={{
                      height: tabElement.showSearchBox ? "72%" : "80%",
                      overflow: "auto",
                      boxSizing: "border-box",
                    }}
                  >
                    {tabElement.tabValueContain}
                  </div>
                </React.Fragment>
              )
            );
          })}
        </div>
      </div>
    </>
  );
};

const TabHeaderDetails = (props) => {
  const { theme, themeName } = useContext(themeContext);
  const activeColor = "#76b1ef";

  return (
    <>
      <div style={{ display: "flex" }}>
        <span
          className="study-list-mobile-filter-active-tab-border"
          style={{ background: props.active ? activeColor : "transparent" }}
        ></span>
        <div className="study-list-mobile-filter-active">
          <span
            className="study-list-mobile-filter-active-dot"
            style={{
              background: props.filterActive ? activeColor : "transparent",
            }}
          ></span>
        </div>

        <span
          className="study-list-mobile-filter-label"
          //style={{ color: props.active ? "white" : "#ffffff7a" }}
          //style={{color: props.active? "var(--mobile-color-txt)":"var(--mobile-color-txt-nonactive"}}
          style={{color: props.active? themeName === "light" ? "#28282B" : "white" :"var(--mobile-color-txt-nonactive"}}
          >
          {props.title}
        </span>
      </div>
    </>
  );
};

const TabContentDetails = (props) => {
  const {
    searchDto,
    filterInputValues,
    setModalityIds,
    storefilterInputValues,
    setFilterInputValues,
  } = useContext(studylistContext);

  const uploadDateRange = [
    { key: "0", text: t("study-list.filters.today"), name: "Today" },
    { key: "1", text: t("study-list.filters.last-1-day"), name: "Last 1 Day" },
    { key: "2", text: t("study-list.filters.last-2-day"), name: "Last 2 Day" },
    {
      key: "7",
      text: t("study-list.filters.last-1-week"),
      name: "Last 1 Week",
    },
    {
      key: "30",
      text: t("study-list.filters.last-1-month"),
      name: "Last 1 Month",
    },
    {
      key: "365",
      text: t("study-list.filters.last-1-year"),
      name: "Last 1 Year",
    },
  ];

  const priorityList = [
    { key: "Critical", text: t("study-list.filters.critical") },
    { key: "High", text: t("study-list.filters.high") },
    { key: "Low", text: t("study-list.filters.low") },
    { key: "Medium", text: t("study-list.filters.medium") },
    { key: "No AI Output", text: t("study-list.filters.no-ai-output") },
    { key: "Results Awaited", text: t("study-list.filters.result-awaited") },
    { key: "Non Frontal Chest", text: t("study-list.filters.non-frontal") },
  ];

  switch (true) {
    case props.id === "sort":
      return <SortByMobile />;

    case props.id === "patient":
      return <SearchFilter handleSearchFocus={props.handleSearchFocus} />;

    case props.id === "modality":
      return (
        <MobileCheckboxFilterList
          id={props.id}
          listToShow={filterInputValues?.modalityList}
        />
      );

    case props.id === "client":
      return (
        <MobileCheckboxFilterList
          id={props.id}
          listToShow={filterInputValues?.clientFirmList}
        />
      );

    case props.id === "pathology":
      return (
        <MobileSelectFilterList
          id={props.id}
          listToShow={filterInputValues?.annotationList}
        />
      );

    case props.id === "uploadDate":
      return (
        <MobileSelectFilterList id={props.id} listToShow={uploadDateRange} />
      );

    case props.id === "priority":
      return <MobileSelectFilterList id={props.id} listToShow={priorityList} />;

    case props.id === "provider":
      return (
        <MobileCheckboxFilterList
          id={props.id}
          listToShow={filterInputValues.radiologistList}
        />
      );
      case props.id === "studydate":
        return (
          <StudyDateFilter 
            id={props.id}
            listToShow={filterInputValues}
          />
        );
    default:
      return <></>;
  }
};

const StudyDateFilter = (props) => {
  const {
    searchDto,
    filterInputValues,
    setModalityIds,
    storefilterInputValues,
    setClientOrFirmIds,
    setPriority,
    setFilterInputValues,
    setProviderIds,
    setStudyDateFrom,studyDateFrom,
    studyDateTo,setStudyDateTo,
    setStudyDate
  } = useContext(studylistContext);

  return (<>
      <DatePicker
        placeholder="Select a date..."
        ariaLabel="Select a date"
        label={t("study-list.filters.study-date-from")}
        // DatePicker uses English strings by default. For localized apps, you must override this prop.
        strings={defaultDatePickerStrings}
        value={studyDateFrom}
        onSelectDate={(data)=>{setStudyDate(data,true);setStudyDateFrom(data)}}
      />
      <DatePicker
        placeholder="Select a date..."
        ariaLabel="Select a date"
        label={t("study-list.filters.study-date-to")}
        // DatePicker uses English strings by default. For localized apps, you must override this prop.
        strings={defaultDatePickerStrings}
        value={studyDateTo}
        onSelectDate={(data)=>{setStudyDateTo(data);setStudyDate(data,false)}}
      />
  </>)
}

const MobileCheckboxFilterList = (props) => {
  const {
    searchDto,
    filterInputValues,
    setModalityIds,
    storefilterInputValues,
    setClientOrFirmIds,
    setPriority,
    setFilterInputValues,
    setProviderIds,
  } = useContext(studylistContext);

  const checkForCheckBoxValues = (value) => {
    switch (true) {
      case props.id == "modality":
        return (
          <Checkbox
            key={value.id}
            label={value.name}
            name={value.name}
            styles={checkboxStyle}
            checked={
              searchDto.modalityIds == null ||
              searchDto.modalityIds == undefined
                ? false
                : searchDto.modalityIds?.includes(value.id)
            }
            onChange={(e, data) => setModalityIds(value.name, value.id, data)}
          />
        );
      case props.id == "client":
        return (
          <Checkbox
            key={value.id}
            label={value.name}
            name={value.name}
            styles={checkboxStyle}
            checked={
              searchDto.clientOrFirmIds == null ||
              searchDto.clientOrFirmIds == undefined
                ? false
                : searchDto.clientOrFirmIds?.includes(value.id)
            }
            onChange={(e, data) =>
              setClientOrFirmIds(value.name, value.id, data)
            }
          />
        );

      case props.id == "provider":
        return (
          <Checkbox
            key={value.id}
            label={
              value.firstName == null || value.firstName == undefined
                ? value.name
                : value.firstName + " " + value.lastName
            }
            name={
              value.firstName == null || value.firstName == undefined
                ? value.name
                : value.firstName + " " + value.lastName
            }
            styles={checkboxStyle}
            checked={searchDto.providerIds?.includes(
              value.firstName == null || value.firstName == undefined
                ? "F"
                : "R" + value.id
            )}
            onChange={(e, data) => setProviderIds(value, value.id, data)}
          />
        );
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          //, width: "21%"
        }}
      >
        {props.listToShow != undefined &&
          searchDto &&
          Array.from(props.listToShow).map((value) => {
            return checkForCheckBoxValues(value);
          })}
      </div>
    </>
  );
};

const MobileSelectFilterList = (props) => {
  const {
    searchDto,
    filterInputValues,
    setModalityIds,
    storefilterInputValues,
    setFilterInputValues,
    setPathology,
    setUploadDate,
    setPriority,
  } = useContext(studylistContext);

  const checkForCheckBoxValues = (value, index) => {
    switch (true) {
      case props.id == "pathology":
        return (
          <li
            onClick={() => setPathology(value)}
            className={`upload-date-li mobile-study-list-li ${
              searchDto.annotationId == value.name
                ? "study-list-active-li mobile-margin-right"
                : ""
            }`}
            key={index}
          >
            {value.name}
          </li>
        );

      case props.id == "uploadDate":
        return (
          <li
            onClick={() => setUploadDate(value)}
            className={`upload-date-li mobile-study-list-li ${
              searchDto.uploadDate == value.key
                ? "study-list-active-li mobile-margin-right"
                : ""
            }`}
            key={value.key}
          >
            {value.text}
          </li>
        );

      case props.id === "priority":
        return (
          <li
            onClick={() => setPriority(value)}
            className={`upload-date-li mobile-study-list-li ${
              searchDto.aiPredictionId == value.key
                ? "study-list-active-li mobile-margin-right"
                : ""
            }`}
            key={value.key}
          >
            {value.text}
          </li>
        );
    }
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          //, width: "21%"
        }}
      >
        <ul className="upload-date-ul">
          {props.listToShow != undefined &&
            Array.from(props.listToShow).map((value, index) => {
              return checkForCheckBoxValues(value, index);
            })}
        </ul>
      </div>
    </>
  );
};

const SortByMobile = (props) => {
  const { sortGlobal, setSortGlobal, selectedValue,setChangeToDropSorting } =
    useContext(studylistContext);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        //, width: "21%"
      }}
    >
      <ul className="upload-date-ul">
        {Array.from(sortOptionsFunction(selectedValue, t)).map(
          (value, index) => {
            return (
              <li
                onClick={(e) => {
                  handleDropDownClick(e, value, setSortGlobal, sortGlobal,setChangeToDropSorting);
                }}
                className={`upload-date-li mobile-study-list-li ${
                  sortGlobal.sortColumn === value.key
                    ? "study-list-active-li"
                    : ""
                }`}
                style={{ position: "relative" }}
                key={index}
              >
                {value.text}
                {sortGlobal.sortColumn === value.key && (
                  <Icon
                    style={{
                      position: "absolute",
                      top: "21%",
                      marginLeft: "5px",
                    }}
                    iconName={
                      sortGlobal.sortOrder === "asc" ? "SortUp" : "SortDown"
                    }
                  ></Icon>
                )}
              </li>
            );
          }
        )}
      </ul>
    </div>
  );
};
